package lacaravana.domain

import lacaravana.app.Database

data class PedidoData(val id: String, val mesaId: Int, val estado: String)

data class PedidoItemData(
    val id: String, val pedidoId: String, val menuItemId: String, val menuItemNombre: String,
    val cantidad: Int, val notas: String?, val estado: String, val precioCents: Int
)

object Pedido {
    suspend fun findByMesa(db: Database, mesaId: Int): PedidoData? {
        val rows = db.query(
            "SELECT id, mesa_id, estado FROM pedidos WHERE mesa_id = ? AND estado = 'abierto'",
            arrayOf(mesaId)
        )
        return rows.firstOrNull()?.let { PedidoData(it[0] as String, (it[1] as Number).toInt(), it[2] as String) }
    }

    suspend fun create(db: Database, mesaId: Int): String {
        val id = js("crypto.randomUUID()") as String
        db.execute("INSERT INTO pedidos (id, mesa_id) VALUES (?, ?)", arrayOf(id, mesaId))
        return id
    }

    suspend fun itemsFor(db: Database, pedidoId: String): List<PedidoItemData> =
        db.query(
            """SELECT pi.id, pi.pedido_id, pi.menu_item_id, mi.nombre, pi.cantidad, pi.notas, pi.estado, mi.precio_cents
               FROM pedido_items pi JOIN menu_items mi ON pi.menu_item_id = mi.id
               WHERE pi.pedido_id = ? ORDER BY pi.id""",
            arrayOf(pedidoId)
        ).map { row ->
            PedidoItemData(
                id = row[0] as String, pedidoId = row[1] as String,
                menuItemId = row[2] as String, menuItemNombre = row[3] as String,
                cantidad = (row[4] as Number).toInt(), notas = row[5] as? String,
                estado = row[6] as String, precioCents = (row[7] as Number).toInt()
            )
        }

    suspend fun addItem(db: Database, pedidoId: String, menuItemId: String, cantidad: Int = 1) {
        val id = js("crypto.randomUUID()") as String
        db.execute(
            "INSERT INTO pedido_items (id, pedido_id, menu_item_id, cantidad) VALUES (?, ?, ?, ?)",
            arrayOf(id, pedidoId, menuItemId, cantidad)
        )
    }

    suspend fun allPendingItems(db: Database): List<PedidoItemData> =
        db.query(
            """SELECT pi.id, pi.pedido_id, pi.menu_item_id, mi.nombre, pi.cantidad, pi.notas, pi.estado, mi.precio_cents
               FROM pedido_items pi JOIN menu_items mi ON pi.menu_item_id = mi.id
               WHERE pi.estado != 'servido' ORDER BY pi.id"""
        ).map { row ->
            PedidoItemData(
                id = row[0] as String, pedidoId = row[1] as String,
                menuItemId = row[2] as String, menuItemNombre = row[3] as String,
                cantidad = (row[4] as Number).toInt(), notas = row[5] as? String,
                estado = row[6] as String, precioCents = (row[7] as Number).toInt()
            )
        }

    suspend fun advanceItemEstado(db: Database, itemId: String) {
        val current = db.query("SELECT estado FROM pedido_items WHERE id = ?", arrayOf(itemId))
        if (current.isEmpty()) return
        val next = when (current[0][0] as String) {
            "pendiente" -> "preparando"
            "preparando" -> "listo"
            "listo" -> "servido"
            else -> return
        }
        db.execute(
            "UPDATE pedido_items SET estado = ?, updated_at = datetime('now') WHERE id = ?",
            arrayOf(next, itemId)
        )
    }
}
